module.exports = __webpack_public_path__ + "img/linux.be3072ce.svg";